// extracted by mini-css-extract-plugin
export default {"quickLink":"quickLinks_quickLink__qj8vv","links":"quickLinks_links__LMFGY"};